import { render, staticRenderFns } from "./home-show.vue?vue&type=template&id=f7c06424&scoped=true&"
import script from "./home-show.vue?vue&type=script&lang=ts&"
export * from "./home-show.vue?vue&type=script&lang=ts&"
import style0 from "./home-show.vue?vue&type=style&index=0&id=f7c06424&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c06424",
  null
  
)

export default component.exports